/**
 * Client-side SKU/barcode generator for the "Add new product" form (business-owner
 * request: an option to generate one instead of always requiring a typed or scanned
 * code). `InventoryItem.sku` is unique per `(tenant_id, branch_id)`, not globally
 * (`backend/app/models/inventory.py`'s `uq_item_tenant_branch_sku`), so this only needs
 * to avoid *practical* collision within one branch's catalog, not guarantee global
 * uniqueness — a timestamp component (changes every millisecond) plus a short random
 * suffix makes an accidental collision astronomically unlikely. On the rare case the
 * backend's own unique constraint still rejects it, `handleCreate`'s existing
 * `ApiError`-message surface already tells the user to try again, same as any other
 * duplicate-SKU submission.
 */
export function generateSku(): string {
  const timePart = Date.now().toString(36).toUpperCase();
  const randomPart = Math.random().toString(36).slice(2, 6).toUpperCase();
  return `SKU-${timePart}-${randomPart}`;
}
